import { useTabContext } from '@mui/lab/TabContext'
import { Link as MUILink, ListItem, Theme, SxProps } from '@mui/material'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import tokens from '../../../styles/tokens.json'
import { Styles } from '../../../types'
import { AnalyticEvent } from '../../../analytics/adobe/types'

const styles: Styles = {
  listItem: {
    padding: 0,
  },
  link: (theme) => ({
    display: 'flex',
    alignItems: 'center',
    paddingX: '0.75rem',
    height: '100%',
    fontFamily: tokens.type.fontFamilies.preloBook,
    fontSize: '1rem',
    textDecoration: 'none',
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
    '&[aria-current="true"]': {
      fontFamily: tokens.type.fontFamilies.preloBold,
    },
  }),
}

const analyticEventType: AnalyticEvent = 'Navigation_Click'

interface RouterLinkProps {
  children: React.ReactNode
  tabIndex?: number
  testId: string
  isCurrent?: boolean
  to: string
  value?: string
  onFocus?: React.FocusEventHandler<HTMLAnchorElement>
  onBlur?: React.FocusEventHandler<HTMLAnchorElement>
  ariaLabel?: string
  linkStyle?: SxProps<Theme> | undefined
  onClick?: () => void
}

const RouterNavListItem = ({
  children,
  isCurrent,
  tabIndex,
  testId,
  to,
  value,
  onFocus,
  onBlur,
  ariaLabel,
  linkStyle = undefined,
  onClick,
}: RouterLinkProps) => {
  const tabContext = useTabContext()
  const isCurrentItem = isCurrent ?? value === tabContext?.value

  return (
    <ListItem sx={styles.listItem}>
      <MUILink
        component={RouterLink}
        sx={linkStyle ?? styles.link}
        to={to}
        aria-label={ariaLabel}
        aria-current={isCurrentItem ?? 'page'}
        tabIndex={tabIndex}
        onClick={onClick}
        onFocus={onFocus}
        onBlur={onBlur}
        data-testid={testId}
        data-analytics-id={testId}
        data-analytic-event={analyticEventType}>
        {children}
      </MUILink>
    </ListItem>
  )
}

export default RouterNavListItem
